import React from "react";

const Loader = ({ imgSize = 24, fontSize = 16 }) => (
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      height: "100%",
    }}
  >
    <img
      src="https://i.imgur.com/llF5iyg.gif"
      alt="Загрузка"
      width={imgSize}
      height={imgSize}
      style={{ marginBottom: 4 }}
    />
    <div style={{ fontSize, lineHeight: 1, color: "#fff" }}>
      Loading data...
    </div>
  </div>
);

export default Loader;
